import { cn } from '@/lib/utils'
import { Accordion, Container, Richtext, Section, Title } from '@/ui/components'
import { getTitleTag } from '@/utils'
import { memo } from 'react'
import { SectionAccordionProps } from './type'

const SectionAccordion = ({
  title,
  titleLayout,
  items,
  text,
  section
}: SectionAccordionProps) => {
  const showLeftSide = (title && titleLayout !== '100') || text

  return (
    <Section data={section} className="s-section-accordion">
      <Container className={''} anim="fade-in">
        <div
          className={cn(
            'gap-gutter grid',
            showLeftSide ? 'lg:grid-cols-2' : 'lg:grid-cols-3'
          )}
        >
          {showLeftSide && (
            <div>
              <Title as={getTitleTag(titleLayout)} className="h2">
                {title}
              </Title>
              <Richtext text={text} />
            </div>
          )}

          <div className={cn(!showLeftSide && 'lg:col-span-2')}>
            <Accordion.Accordion
              items={items}
              id={section?.id?.toString() ?? undefined}
            />
          </div>
        </div>
      </Container>
    </Section>
  )
}

SectionAccordion.displayName = 'SectionAccordion'

export default memo(SectionAccordion)
